import { language } from "language/default";
const getItem = (root, id, pointName, pointValue) => {
    const item = root.find((r) => r.entityAlias === id);
    const itemName = item?.items?.[0]?.measures?.[pointName.aggregate]?.toString() ?? item?.items?.[0]?.data?.[0]?.measures?.[pointName.aggregate]?.toString() ?? "-";
    const kpiItem = item?.customResult?.[0];
    const itemValue = kpiItem?.value?.value;
    return {
        name: itemName,
        tooltip: [
            [pointName.title, itemName],
            [pointValue.title, kpiItem?.value?.formattedValue]
        ],
        value: itemValue
    };
};
export const kpi = (params) => (args) => {
    const mainId = args.context.request?.entityAlias ?? "", [comparateId] = args.context.request?.comparates.map((c) => c.alias) || [];
    const diffId = `${mainId}-${comparateId}`, entityNameColumn = params[1], entityValueColumn = params[0];
    const comparate = getItem(args.context.staticData.root, comparateId, entityNameColumn, entityValueColumn), diff = getItem(args.context.staticData.root, diffId, entityNameColumn, entityValueColumn), diffName = language.en.widget.difference, main = getItem(args.context.staticData.root, mainId, entityNameColumn, entityValueColumn);
    args.context.staticData.customResult = !main.value && !comparate.value
        ? []
        : [
            {
                name: main.name,
                series: [{ custom: { tooltip: main.tooltip }, name: main.name, title: main.name, y: main.value }]
            },
            {
                name: comparate.name,
                series: [
                    { custom: { tooltip: comparate.tooltip }, name: comparate.name, title: comparate.name, y: comparate.value },
                    { custom: { tooltip: diff.tooltip }, isTotal: true, name: diffName, title: diffName, y: diff.value }
                ]
            }
        ];
};
